import React from "react";
import Countdown from "react-countdown";

type viewTypes = "phoneVerification" | "otpConfirmation";
export interface OtpConfirmationTimerProps {
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  timerEnd: number;
  setView: React.Dispatch<React.SetStateAction<viewTypes>>;
}

const Timer: React.FC<OtpConfirmationTimerProps> = ({
  setDisabled,
  timerEnd,
  setView,
}) => {
  const handleFinishCountdown = () => {
    setDisabled(true);
    setView("phoneVerification");
  };

  return (
    <Countdown
      date={timerEnd}
      onComplete={handleFinishCountdown}
      renderer={({ minutes, seconds }) => {
        return (
          <span>
            {`${minutes < 10 ? `0${minutes}` : minutes}:${
              seconds < 10 ? `0${seconds}` : seconds
            }`}
          </span>
        );
      }}
    />
  );
};

export default Timer;
